module.exports = __webpack_public_path__ + "static/media/IMG_20210620_125712_676.198baa9e.jpg";